/*
 * @Author: edvardchen
 * @Date:   2016-11-22 21:28:48
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-10-22 11:54:32
 */

import querystring from 'query-string';
import _ from 'lodash';

import { post, get, put } from './fetch';
type Report = {
  logType: number, // 1为曝光 2为点击
  logKey?: string, // 对应F7字段，与ivan那边对应一致
  logContent?: string, // "字符串以|为分割，对应自定义日志F9及以后字段"
  contentType?: number,
};
const handleError = (err) => {
  const code = _.get(err, 'body.code') || _.get(err, 'iRtnCode');
  if (code === -101 || code === -102) {
    window.onLoginSessionChanged && window.onLoginSessionChanged();
  }
  throw err;
};

export const getNewComment$NEW = (reqData) => post(`/api/comments/more?${querystring.stringify(reqData)}`);

export function getHotComment$NEW({ postId, circleId, niceComment }) {
  if (!postId || !circleId) {
    const error = new Error(`Params Missing: postId: ${postId}, circleId: ${circleId}.`);
    throw error;
  }

  return post(niceComment ? '/api/comments/nice' : '/api/comments/hot', {
    body: {
      postId,
      circleId,
    },
  }).catch(handleError);
}

export const getCommentSummary = (params) => get(`/api/comments/detail?${querystring.stringify(params)}`);

/**
 * 拉黑用户
 * @param  {Number} options.type accountType
 * @param  {String} options.id   userId
 */
export function forbidUser({ type, id }) {
  return put('/api/circles/forbiduser', {
    body: {
      type,
      id,
    },
  });
}

/**
 * 举报
 * @param  {Number} options.reason   举报原因
 */
export function accuse({ circleId, postId, id, reason }) {
  return put('/api/circles/accuse', {
    body: {
      circleId,
      postId,
      id,
      reason,
    },
  }).catch(handleError);
}

/**
 * 评论加精
 * @param  {String} options.circleId
 * @param  {String} options.postId
 * @param  {String} options.commentId
 * @param  {Number} options.manageType
 */
export function setNicePost({ circleId, postId, commentId, manageType }) {
  return put('/api/circles/setNicePost', {
    body: {
      circleId,
      postId,
      commentId,
      manageType,
    },
  }).catch(handleError);
}

/**
 * 删除评论
 * @param  {String} options.circleId
 * @param  {String} options.postId
 * @param  {String} options.commentId
 */
export function delComment({ circleId, postId, commentId }) {
  return post('/api/comments/delete', {
    body: {
      circleId,
      postId,
      commentId,
    },
  }).catch(handleError);
}

/**
 * 点赞
 * @param  {String} options.circleId
 * @param  {String} options.postId
 * @param  {String} options.id       评论ID
 * @return {Promise}
 */
export function praise({ circleId, postId, id }) {
  const params = querystring.stringify({ circleId, postId, id });
  const url = `/api/comments/praise?${params}`;
  return put(url).catch(handleError);
}

/**
 * 点赞帖子/答案
 * @param {String} id
 * @param {String} circleId
 */
export function praisePost({ circleId, id: postId, isLike, ext = {} }) {
  const params = querystring.stringify({
    circleId,
    postId,
    isLike: +isLike,
    ext: JSON.stringify(ext),
  });
  return put(`/api/posts/praise?${params}`).catch(handleError);
}

export function getArticlePostInfo({ docId, tabId, tagId }) {
  const params = {
    docId,
    tabId,
    tagId,
  };
  return get(`/api/circles?${querystring.stringify(params)}`, {
    headers: {
      'Cache-Control': 'no-cache',
    },
  });
}

export function lockPost({ postId }) {
  return put(`/api/circles/posts/${postId}/lock`).catch(handleError);
}

export function unlockPost({ postId }) {
  return put(`/api/circles/posts/${postId}/unlock`).catch(handleError);
}

export function getHotComment({ postId, circleId }) {
  if (!postId || !circleId) {
    return;
  }
  return post('/api/hotcomments', {
    body: {
      postId,
      circleId,
    },
  }).catch(handleError);
}

export function getNewComment({ direction, circleId, postId, position, startTime, lastId }) {
  const params = querystring.stringify({
    position,
    lastId,
    startTime,
    direction,
    postId,
    circleId,
  });
  return post(`/api/comments/more/old?${params}`).catch(handleError);
}

export function getNewMsg() {
  return get('/api/circles/messages/new').catch(handleError);
}

export function getMoreAnswers({ questionId, ...rest }) {
  const params = querystring.stringify(rest);
  return get(`/api/questions/${questionId}/answers?${params}`);
}

export function getVote({ postId }: { postId: string }) {
  return post('/api/getvote', {
    body: {
      postId,
    },
  }).catch(handleError);
}

export function vote({
  postId,
  circleId,
  idx,
  contentId,
  subjectId,
}: {
  postId: string,
  circleId: string,
  idx: number,
  contentId: string,
  subjectId: string,
}) {
  return post('/api/vote', {
    body: {
      postId,
      circleId,
      idx,
      contentId,
      subjectId,
    },
  }).catch(handleError);
}

export function getAnchorComment(body) {
  return post('/api/comments/anchor', {
    body,
  }).catch(handleError);
}

export function getUserHonorInfoEx({ users = [] }: { users: *[] }) {
  const accounts = JSON.stringify(users);
  return post('/api/circles/getUserHonorInfoEx', {
    body: {
      accounts,
    },
  }).catch(handleError);
}

export function downvote({ postId }) {
  return put(`/api/posts/downvote?postId=${postId}`).catch(handleError);
}

/**
 * 拉黑用户
 * @param  {Number} options.type accountType
 * @param  {String} options.id   userId
 */
export function getGuess({ postId, guessIndex }) {
  return post('/api/circles/guess', {
    body: { postId, guessIndex },
  }).catch(handleError);
}

/**
 * 区别世界杯的竞猜
 * @param  {Number} options.postId 竞猜对应帖子Id
 * @param  {String} options.guessIndex   竞猜选项id
 */
export function getGuessNew({ postId, guessIndex }: { postId: string, guessIndex: string }) {
  return post('/api/circles/guessnew', {
    body: { postId, guessIndex },
  }).catch(handleError);
}

/**
 * 获取docId和subjectId关联的投票信息，目前这个接口只返回pk的投票数计，如其他类型加了ui显示可以在后台放开
 */
export function getRelatedVote({
  docId,
  subjectId,
  tagId,
  postId,
}: {
  docId: string,
  subjectId?: string,
  postId: string,
}) {
  return post('/api/circles/getRelatedVote', {
    body: {
      docId,
      subjectId,
      postId,
      tagId,
    },
  }).catch(handleError);
}

/**
 * 获取docId和subjectId关联的投票信息，目前这个接口只返回pk的投票数计，如其他类型加了ui显示可以在后台放开
 */
export function getPostSummary({
  docId,
  subjectId,
  tagId,
  postId,
}: {
  docId: string,
  subjectId?: string,
  postId: string,
}) {
  return post('/api/circles/getPostSummary', {
    body: {
      docId,
      subjectId,
      postId,
      tagId,
    },
  }).catch(handleError);
}

/**
 * 关注圈子
 */
export function followCircle({ circleId }: { circleId: string }) {
  return post('/api/circles/followCircle', {
    body: {
      circleId,
    },
  }).catch(handleError);
}

/**
 * 取消关注圈子
 */
export function unfollowCircle({ circleId }: { circleId: string }) {
  return post('/api/circles/unfollowCircle', {
    body: {
      circleId,
    },
  }).catch(handleError);
}

/**
 * 获取分享者信息
 * @param  {Number} options.actType accountType
 * @param  {String} options.sId   userId
 */
export function getSharePageUserInfo({ actType, sId, guid }: { actType: string, sId: string, guid: string }) {
  return post('/api/circles/getSharePageUserInfo', {
    body: { actType, sId, guid },
  }).catch(handleError);
}

/**
 * 图片上传
 * @param params
 */
export function uploadFile(params) {
  return post('/api/circles/uploadFile', {
    body: params,
  });
}

/**
 * 正文底部配置的运营
 * @param  {String} options.guid   guid
 */
export function getShareNewsLandPages() {
  return post('/api/circles/getShareNewsLandPages', {
    body: {},
  }).catch(handleError);
}
/** **
 *
 */
export function customerLogReport({ logType, logKey = '', logContent, contentType = 0 }: Report) {
  return post('/api/circles/customerLogReport', {
    body: { logType, logKey, logContent, contentType },
  }).catch(handleError);
}

export function followPerson({ userId, accountType }: { userId: string, accountType: number }) {
  return post('/api/circles/followPerson', {
    body: { userId, accountType },
  }).catch(handleError);
}

export function unFollowPerson({ userId, accountType }: { userId: string, accountType: number }) {
  return post('/api/circles/unFollowPerson', {
    body: { userId, accountType },
  }).catch(handleError);
}

export function writeComment({
  sText,
  circleId,
  postId,
  parentCommentId,
}: {
  sText: string,
  circleId: string,
  postId: string,
  parentCommentId: string,
}) {
  return post('/api/circles/writeComment', {
    body: { sText, circleId, postId, parentCommentId },
  });
}

/**
 * 获取当前用户权限
 * */
export function getUserAuthInfo({ userId, accountType }: { userId: string, accountType: number }) {
  return post('/api/circles/getUserAuthInfo', {
    body: { userId, accountType },
  });
}

export function getOprMsgs() {
  return post('/api/circles/getOprMsgs', {
    body: {},
  });
}

export function ackOprMsgs({ msgs = '' }: { msgs: string }) {
  return post('/api/circles/ackOprMsgs', {
    body: { msgs },
  });
}

/**
 * 获取部落后台返回的讨论卡片数据
 */
export function getDiscussCard({
  docId,
  tags,
  postId,
  subjectId,
  mainSubjectId,
  reportParams,
}: {
  docId: string,
  tags: [],
  postId: string,
}) {
  return post('/api/circles/getDiscussCard', {
    body: {
      docId,
      postId,
      tags: JSON.stringify(tags),
      subjectId,
      mainSubjectId,
      reportParams: JSON.stringify(reportParams),
    },
  }).catch(handleError);
}
